export default __webpack_public_path__ + "static/1-635fc115b7d799983a3a02926db54bdf.gif";